import MunicipalitySelect from '@/components/MunicipalitySelect';
import PhoneEditor from '@/components/PhoneNumberField/PhoneEditor';
import Phones from '@/components/PhoneNumberField/PhonesListView';
import ProvinceSelect from '@/components/ProvinceSelect';
import { validations } from '@/utils/fields';
import { renderMunicipality, renderProvince } from '@/utils/location';

export const fields = [
  {
    key: 'name',
    label: 'name',
    colSpan: 2,
    required: true,
    className: 'form-view-mode-vertical-item'
  },
  {
    key: 'phone',
    colSpan: 2,
    required: false,
    label: 'phones',
    rules: [validations.listPhones(), validations.phoneValidator()],
    widget: PhoneEditor,
    viewWidget: Phones,
    viewWidgetProps: {
      useLink: false,
      columns: true
    },
    className: 'form-view-mode-vertical-item'
  },
  {
    key: 'email',
    colSpan: 2,
    label: 'email',
    rules: [{ type: 'email' }],
  },
  {
    key: 'address.province',
    label: 'province',
    required: true,
    onlyEdit: true,
    colSpan: 1,
    widget: ProvinceSelect
  },
  {
    key: 'address.province',
    required: true,
    label: 'province',
    onlyView: true,
    widget: ProvinceSelect,
    viewWidget: ({ value }) => renderProvince(value)
  },
  {
    key: 'address.municipality',
    label: 'municipality',
    required: true,
    onlyEdit: true,
    colSpan: 1,
    related: 'address.province',
    relatedKey: 'province',
    widget: MunicipalitySelect
  },
  {
    key: 'address.municipality',
    required: true,
    onlyView: true,
    label: 'municipality',
    viewWidget: ({ value }) => renderMunicipality(value)
  },
  {
    key: 'address.abstract',
    label: 'address',
    widget: 'textarea',
    className: 'form-view-mode-vertical-item',
    required: true,
  },
];
